import React from 'react';
interface IconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
  className?: string;
}
const defaultProps = {
  stroke: 'currentColor',
  strokeWidth: '1.5',
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  fill: 'none'
};
// --- Service Icons ---
export const FaceSparkleIcon = ({
  size = 24,
  className = '',
  ...props
}: IconProps) => <svg width={size} height={size} viewBox="0 0 24 24" className={className} {...defaultProps} {...props} data-id="element-281">
    <path d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z" data-id="element-282" />
    <path d="M9 10h.01M15 10h.01M12 14c-1.5 0-2.5.5-3 1.5M18 6l1-1M19 8l1 1M17 9l-1 1" data-id="element-283" />
  </svg>;
export const WaterDropIcon = ({
  size = 24,
  className = '',
  ...props
}: IconProps) => <svg width={size} height={size} viewBox="0 0 24 24" className={className} {...defaultProps} {...props} data-id="element-284">
    <path d="M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-6.5c-.5 2.5-2 4.9-4 6.5C6 11.1 5 13 5 15a7 7 0 0 0 7 7z" data-id="element-285" />
    <path d="M12 18a3 3 0 0 0 3-3" data-id="element-286" />
  </svg>;
export const VialIcon = ({
  size = 24,
  className = '',
  ...props
}: IconProps) => <svg width={size} height={size} viewBox="0 0 24 24" className={className} {...defaultProps} {...props} data-id="element-287">
    <path d="M9 2h6M12 2v4M10 6h4v13a2 2 0 0 1-2 2h0a2 2 0 0 1-2-2V6zM10 12h4M10 16h4" data-id="element-288" />
  </svg>;
export const PenNeedleIcon = ({
  size = 24,
  className = '',
  ...props
}: IconProps) => <svg width={size} height={size} viewBox="0 0 24 24" className={className} {...defaultProps} {...props} data-id="element-289">
    <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z" data-id="element-290" />
    <path d="m15 5 4 4M2 22l4-4M5 19l-2-2" data-id="element-291" />
  </svg>;
export const BodySilhouetteIcon = ({
  size = 24,
  className = '',
  ...props
}: IconProps) => <svg width={size} height={size} viewBox="0 0 24 24" className={className} {...defaultProps} {...props} data-id="element-292">
    <path d="M12 7a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" data-id="element-293" />
    <path d="M6 10c0-2 2-3 6-3s6 1 6 3v5c0 2-1 3-2 4l-2 3v-2h-4v2l-2-3c-1-1-2-2-2-4v-5z" data-id="element-294" />
  </svg>;
export const SunLaserIcon = ({
  size = 24,
  className = '',
  ...props
}: IconProps) => <svg width={size} height={size} viewBox="0 0 24 24" className={className} {...defaultProps} {...props} data-id="element-295">
    <circle cx="12" cy="12" r="4" data-id="element-296" />
    <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" data-id="element-297" />
  </svg>;
export const SparkTweezerIcon = ({
  size = 24,
  className = '',
  ...props
}: IconProps) => <svg width={size} height={size} viewBox="0 0 24 24" className={className} {...defaultProps} {...props} data-id="element-298">
    <path d="M4 4l6 16 2-4 4-2 6-2-16-8z" data-id="element-299" />
    <circle cx="18" cy="6" r="2" data-id="element-300" />
  </svg>;
export const LipsIcon = ({
  size = 24,
  className = '',
  ...props
}: IconProps) => <svg width={size} height={size} viewBox="0 0 24 24" className={className} {...defaultProps} {...props} data-id="element-301">
    <path d="M2 12c2.5-3 5.5-4 10-4s7.5 1 10 4c-2.5 3-5.5 5-10 5s-7.5-2-10-5z" data-id="element-302" />
    <path d="M2 12c2.5 1 5.5 2 10 2s7.5-1 10-2" data-id="element-303" />
  </svg>;
export const IVBagIcon = ({
  size = 24,
  className = '',
  ...props
}: IconProps) => <svg width={size} height={size} viewBox="0 0 24 24" className={className} {...defaultProps} {...props} data-id="element-304">
    <path d="M12 2v4M9 6h6v10a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2V6zM12 18v4M10 10h4M10 14h4" data-id="element-305" />
  </svg>;
// --- UI Icons ---
export const CheckIcon = ({
  size = 24,
  className = '',
  ...props
}: IconProps) => <svg width={size} height={size} viewBox="0 0 24 24" className={className} {...defaultProps} {...props} data-id="element-306">
    <path d="M20 6L9 17l-5-5" data-id="element-307" />
  </svg>;
export const XIcon = ({
  size = 24,
  className = '',
  ...props
}: IconProps) => <svg width={size} height={size} viewBox="0 0 24 24" className={className} {...defaultProps} {...props} data-id="element-308">
    <path d="M18 6L6 18M6 6l12 12" data-id="element-309" />
  </svg>;
export const StarIcon = ({
  size = 24,
  className = '',
  ...props
}: IconProps) => <svg width={size} height={size} viewBox="0 0 24 24" className={className} {...defaultProps} {...props} data-id="element-310">
    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" data-id="element-311" />
  </svg>;
export const InstagramIcon = ({
  size = 24,
  className = '',
  ...props
}: IconProps) => <svg width={size} height={size} viewBox="0 0 24 24" className={className} {...defaultProps} {...props} data-id="element-312">
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5" data-id="element-313" />
    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" data-id="element-314" />
    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" data-id="element-315" />
  </svg>;
export const PhoneIcon = ({
  size = 24,
  className = '',
  ...props
}: IconProps) => <svg width={size} height={size} viewBox="0 0 24 24" className={className} {...defaultProps} {...props} data-id="element-316">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" data-id="element-317" />
  </svg>;
export const MapPinIcon = ({
  size = 24,
  className = '',
  ...props
}: IconProps) => <svg width={size} height={size} viewBox="0 0 24 24" className={className} {...defaultProps} {...props} data-id="element-318">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" data-id="element-319" />
    <circle cx="12" cy="10" r="3" data-id="element-320" />
  </svg>;
export const GlobeIcon = ({
  size = 24,
  className = '',
  ...props
}: IconProps) => <svg width={size} height={size} viewBox="0 0 24 24" className={className} {...defaultProps} {...props} data-id="element-321">
    <circle cx="12" cy="12" r="10" data-id="element-322" />
    <line x1="2" y1="12" x2="22" y2="12" data-id="element-323" />
    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" data-id="element-324" />
  </svg>;
export const MenuIcon = ({
  size = 24,
  className = '',
  ...props
}: IconProps) => <svg width={size} height={size} viewBox="0 0 24 24" className={className} {...defaultProps} {...props} data-id="element-325">
    <line x1="3" y1="12" x2="21" y2="12" data-id="element-326" />
    <line x1="3" y1="6" x2="21" y2="6" data-id="element-327" />
    <line x1="3" y1="18" x2="21" y2="18" data-id="element-328" />
  </svg>;
export const ChevronIcon = ({
  size = 24,
  className = '',
  ...props
}: IconProps) => <svg width={size} height={size} viewBox="0 0 24 24" className={className} {...defaultProps} {...props} data-id="element-329">
    <polyline points="6 9 12 15 18 9" data-id="element-330" />
  </svg>;
export const QuoteIcon = ({
  size = 24,
  className = '',
  ...props
}: IconProps) => <svg width={size} height={size} viewBox="0 0 24 24" className={className} {...defaultProps} {...props} data-id="element-331">
    <path d="M3 21c3 0 7-1 7-8V5c0-1.25-.756-2.017-2-2H4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2 1 0 1 0 1 1v1c0 1-1 2-2 2s-1 .008-1 1.036c0 3 1 3 1 3z" data-id="element-332" />
    <path d="M15 21c3 0 7-1 7-8V5c0-1.25-.757-2.017-2-2h-4c-1.25 0-2 .75-2 1.972V11c0 1.25.75 2 2 2h.75c0 2.25.25 4-2.75 4v3c0 1 1 1 1 1z" data-id="element-333" />
  </svg>;
export const FlowerIcon = ({
  size = 24,
  className = '',
  ...props
}: IconProps) => <svg width={size} height={size} viewBox="0 0 24 24" className={className} {...defaultProps} {...props} data-id="element-334">
    <path d="M12 22c4-4 4-10 0-14-4 4-4 10 0 14z" data-id="element-335" />
    <path d="M12 8c4 4 10 4 14 0-4-4-10-4-14 0z" transform="rotate(45 12 12)" data-id="element-336" />
    <path d="M12 8c4 4 10 4 14 0-4-4-10-4-14 0z" transform="rotate(90 12 12)" data-id="element-337" />
    <path d="M12 8c4 4 10 4 14 0-4-4-10-4-14 0z" transform="rotate(135 12 12)" data-id="element-338" />
    <circle cx="12" cy="12" r="2" data-id="element-339" />
  </svg>;
export const LightbulbIcon = ({
  size = 24,
  className = '',
  ...props
}: IconProps) => <svg width={size} height={size} viewBox="0 0 24 24" className={className} {...defaultProps} {...props} data-id="element-340">
    <path d="M9 18h6M10 21h4M12 3a6 6 0 0 0-4 10.5c.7.7 1.2 1.5 1.4 2.5h5.2c.2-1 .7-1.8 1.4-2.5A6 6 0 0 0 12 3z" data-id="element-341" />
  </svg>;